module.exports = "https://www.gc-qa.gnp.com.mx/a5ace5a53d329f7dbb76983c0dd623f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/documentos-icono.png
// module id = 965
// module chunks = 0